// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Slider from "react-slick";
import "react-slick/dist/react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './FilterSwatchOptions.style';
import PriceFilter from './PriceFilter.component';
import CaratFilter from './CaratFilter.component';
import ProductAttributeValue from 'Component/ProductAttributeValue';

export class FilterSwatchOptions extends PureComponent {
    static propTypes = {
        // renderConfigurableAttributeValue: this.propTypes,
        attribute_code: this.propTypes,
        attributevalue: this.propTypes,
        option: this.propTypes,
        attribute_values: this.propTypes,
        handleOptionClick: this.propTypes,
        isSelected: this.propTypes,
        getIsConfigurableAttributeAvailable: this.propTypes,
        getLink: this.propTypes,
        showProductAttributeAsLink: this.propTypes,
        inStock: this.propTypes
    };

    typesettings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        autoPlay: false,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 1299,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 810,
                settings: {
                    slidesToShow: 8,
                    slidesToScroll: 8,
                }
            },
            {
                breakpoint: 667,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 7,
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
        ]
    };

    styletypesettings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoPlay: false,
        responsive: [
            {
                breakpoint: 1168,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 810,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
        ]
    };

    widthtypesettings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        autoPlay: false,
        responsive: [
            {
                breakpoint: 1168,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 810,
                settings: {
                    slidesToShow: 8,
                    slidesToScroll: 8,
                }
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 7,
                }
            },
            {
                breakpoint: 668,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
        ]
    };

    handleChangeShape = (value, option) => {
        const {
            handleOptionClick,
            isSelected
        } = this.props;

        if (isSelected({ ...option, attribute_value: value.value ? value.value : value.value_string })) {
            console.log(isSelected({ ...option, attribute_value: value.value ? value.value : value.value_string }));
            const styele = document.querySelectorAll(".style-container .slick-track");

            if (styele?.length > 0) {
                // styele[0].style.transform = "translate3d(0, 0, 0)";
                const style = styele[0].getAttribute("style") + " transform: translate3d(0, 0, 0);";
                styele[0].setAttribute("style", style)
                console.log(styele[0].getAttribute("style"));
            }
        }

        handleOptionClick({ ...option, attribute_value: value.value ? value.value : value.value_string });
    }

    // carat filter
    renderCaratWeight() {
        return (
            <CaratFilter />
        )
    }

    // shape  filter
    renderShape = (attributevalue, option) => {
        const {
            isSelected,
        } = this.props;

        const ringdiamond = JSON.parse(localStorage.getItem("diamond"));

        if (ringdiamond) {
            if (option?.attribute_code === "shape") {
                const attributeoptions = Object.values(option?.attribute_options);
                const hasdiamondshapematch = attributeoptions.find((valuefilyter) => {
                    return valuefilyter.label === ringdiamond?.diamond_shape
                });

                if (hasdiamondshapematch) {
                    option = {
                        ...option,
                        attribute_options: {
                            [hasdiamondshapematch?.value_string]: hasdiamondshapematch
                        },
                        attribute_values: [hasdiamondshapematch?.value_string]
                    }

                    attributevalue = [hasdiamondshapematch];

                    if (!isSelected({ ...option, attribute_value: hasdiamondshapematch?.value_string })) {
                        this.handleChangeShape(attributevalue[0], option)
                    }
                }
            }
        }

        return (
            <div className='shape-filter'>
                <Slider {...this.typesettings}>
                    {
                        attributevalue?.map((value, index) => (
                            <div
                                className={isSelected({ ...option, attribute_value: value.value ? value.value : value.value_string }) ? 'shape-filter-content shape-filter-content_isSelected' : 'shape-filter-content'}
                                key={index}
                            >
                                <div
                                    className='shape-filter-icon-contenet'
                                    onClick={() => this.handleChangeShape(value, option)}
                                >
                                    {
                                        value.swatch_data.value !== null ?
                                            <img src={`/media/attribute/swatch${value.swatch_data.value}`} />
                                            : ""
                                    }
                                </div>
                                <span className='shape-title'>{value.label}</span>
                            </div>
                        ))
                    }
                </Slider>
            </div>
        )
    }

    // metal type filter
    renderMetalType = (attributevalue, option) => {
        const {
            isSelected,
        } = this.props;


        return (
            <div className='metaltype-container'>
                <Slider {...this.typesettings}>
                    {
                        attributevalue.map((value, index) => (
                            <div className='metal-type-option-container' key={index}>
                                <div
                                    className={
                                        isSelected({ ...option, attribute_value: value.value ? value.value : value.value_string }) ?
                                            'metal-type-options metal-type-options_isSelected'
                                            : 'metal-type-options'
                                    }
                                    onClick={() => this.handleChangeShape(value, option)}
                                >
                                    <img src={`/media/attribute/swatch${value.swatch_data.value}`} />
                                </div>
                            </div>
                        ))
                    }
                </Slider>
            </div>
        )
    }

    // style filter
    renderStyle = (attributevalue, option) => {
        const {
            isSelected,
        } = this.props;

        return (
            <div className='style-container'>
                <Slider {...this.styletypesettings}>
                    {
                        attributevalue.map((value, index) => (
                            <div
                                className={isSelected({ ...option, attribute_value: value.value_string }) ? 'style-options style-options_isSelected' : 'style-options'}
                                onClick={() => this.handleChangeShape(value, option)}
                                key={index}
                            >
                                <span>{value.label}</span>
                            </div>
                        ))
                    }
                </Slider>
            </div>
        )
    }

    // price filter
    renderPrice() {
        return (
            <PriceFilter />
        )
    }

    // width filter
    renderWidth(attribute_values, option) {
        return (
            <div className='style-container'>
                <Slider {...this.widthtypesettings}>
                    {
                        attribute_values.map((attribute_value) => (
                            this.renderConfigurableAttributeValue(
                                { ...option, attribute_value: attribute_value }
                            )
                        ))
                    }
                </Slider>
            </div>
        )
    }

    // default filter
    renderConfigurableAttributeValue(attribute) {
        const {
            getIsConfigurableAttributeAvailable,
            handleOptionClick,
            getLink,
            isSelected,
            showProductAttributeAsLink,
            inStock,
        } = this.props;

        const { attribute_value } = attribute;

        return (
            <ProductAttributeValue
                key={attribute_value}
                attribute={attribute}
                isSelected={isSelected(attribute)}
                isAvailable={getIsConfigurableAttributeAvailable(attribute) && inStock}
                onClick={handleOptionClick}
                getLink={getLink}
                showProductAttributeAsLink={showProductAttributeAsLink}
                onMouseEnter={handleOptionClick}
            />
        );
    }

    renderFilterSwatch() {
        const {
            attribute_code,
            attributevalue,
            option,
            attribute_values
        } = this.props;

        switch (attribute_code) {
            case "ring_setting_carat_weight":
            case "total_carat_weight":
                return this.renderCaratWeight();
            // case "dia_gem_shape":
            // case "shape":
            //     return this.renderShape(attributevalue, option);
            // case "metal_type":
            // case "metal":
            // case "metal_color":
            //     return this.renderMetalType(attributevalue, option);
            // case "style":
            //     return this.renderStyle(attributevalue, option);
            case "price":
                return this.renderPrice();
            // case "width":
            //     return this.renderWidth(attribute_values, option);
            default:
                return (
                    attribute_values.map((attribute_value) => (
                        this.renderConfigurableAttributeValue(
                            { ...option, attribute_value: attribute_value }
                        )
                    ))
                );
        }
    }

    render() {
        return (
            this.renderFilterSwatch()
        );
    }
}

export default FilterSwatchOptions;
